import React, { createContext, useReducer } from "react";
import Reducer from "./Reducer";

export const initialContextState = {
  toggleDrawer: false,
  isMenuHighlighted: false,
  drawerIsOpened: true,
  pagination: {
    rowPerPage: 50,
    page: 0,
    count: 0,
  },
  context_pagination: {
    rowPerPage: 50,
    page: 0,
    count: 0,
  },
  errors: null,
  accounts: null,
  account: null,
  subscriptions: null,
  lang: null,
  roles : [],
  user: null,
  isSuperAdminUser: false,
  superAdminConnectedAsRoles: [],
  dossierGraphTableLink: [],
  thirdpartiesGraphTableLink: [],
  dossierToolbarFilters: [],
  thirdpartiesToolbarFilters: [],
  usersToolbarFilters: [],
  dossierTypes: [],
  inactiveDossierTypes: [],
  contactsToolbarFilters: [],
  crumbsData: null,
  graphFilters: {},
  isAuthDone : false,
  provisioning : false,
  referenceData: {},
  contextInstance: null,
  contextThirdParty: null,
  isCreatingContextInstance: false,
  isAssociatingContextThirdParty: false,
  contextModels: [],
  contextInstances: null,
  contextThirdParties: [],
  thirdparty: null,
  thirdpartyContacts: null,
  personalization: {},
  doctypeTraductions: [],
  legalActivityTraductions: {},
  activityTraductions: [],
  activityMapByOrigin: new Map(),
  availableReports: []
};

export const Context = createContext(initialContextState);

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialContextState);
  return (
    <Context.Provider
      value={[state, dispatch]}
      displayName="365 Context"
    >
      {children}
    </Context.Provider>
  );
};

export default Store;
